<section class="profile-results-star-description" (click)="toogleShowModal()">
  <div class="profile-results-star-description__modal">
    <div class="profile-results-star-description__close">
      <mat-icon class="close-icon" (click)="toogleShowModal()">close</mat-icon>
    </div>
    <div class="profile-results-star-description__message">
    <span class="profile-results-star-description__message__title">
      <img src="{{ starImg }}" alt="*">
      <span>{{ title }}</span>
    </span>
      <span class="profile-results-star-description__message__explanation"> - {{ explanation }}</span>

      <ng-container *ngIf="exercises?.length">
        <div *ngFor="let exercise of exercises; let i=index">

          <div *ngIf="exercise.exercise_type == calculation"
               class="exercise-calculation profile-results-exercises__box__card__exercises__item" [ngClass]="getTaskSpacingStyle(i)">
            <span class="profile-results-exercises__box__card__exercises__item__number">{{i + 1}})&nbsp;&nbsp;</span>
            <span>
              <ng-katex-paragraph
                class="katex text katex-p"
                [paragraph]="exercise.exercise_text | exerciseFormat:'text'">
                </ng-katex-paragraph>
            </span>
          </div>

          <div *ngIf="exercise.exercise_type == task || exercise.exercise_type == logic" class="exercise-task" [ngClass]="getTaskSpacingStyle(i)">
            <div>
              <span class="profile-results-exercises__box__card__exercises__item__number">{{i + 1}})&nbsp;&nbsp;</span>
              <span>
              <ng-katex-paragraph
                class="katex text katex-p"
                [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
              </ng-katex-paragraph>
            </span>
              <ng-container *ngIf="exercise.answer_by_question && exercise.answer_by_question.length > 0">
              <span class="exercise-text" *ngFor="let question of exercise.answer_by_question">
                <ng-katex-paragraph
                  class="katex text katex-p"
                  [paragraph]="question.text | exerciseFormat:'text'">
                </ng-katex-paragraph>
              </span>
              </ng-container>
            </div>
          </div>

          <div *ngIf="exercise.exercise_type == magic_box" >
            <table class="magic-box">
              <tr *ngFor="let row of getMagicBoxObject(exercise.exercise_text); let magic_row=index">
                <td *ngFor="let elem of row; let magic_elem=index" [ngClass]="getMagicBoxTdStyle(elem,exercise,magic_row,magic_elem)">
                  <div *ngIf="elem != null" class="magic-box-cell-task">{{ elem }}</div>
                  <div *ngIf="elem == null && compareMagicBoxAnswers(exercise,magic_row,magic_elem)" class="magic-box-cell-right">{{ getMagicBoxCellRight(exercise,magic_row,magic_elem) }}</div>
                  <div *ngIf="elem == null && !compareMagicBoxAnswers(exercise,magic_row,magic_elem)"><span class="magic-box-cell-right-above-wrong">{{ getMagicBoxCellRight(exercise,magic_row,magic_elem) }}</span><span class="magic-box-cell-wrong">{{ getMagicBoxCellWrong(exercise,magic_row,magic_elem) }}</span></div>
                </td>
              </tr>
            </table>
          </div>

          <div *ngIf="exercise.exercise_type == sequence" class="exercise-sequence" [ngClass]="getTaskSpacingStyle(i)">
            <span class="profile-results-exercises__box__card__exercises__item__number">{{i + 1}})&nbsp;&nbsp;</span>
            <span>
            <ng-katex-paragraph
              class="katex text katex-p"
              [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
            </ng-katex-paragraph>
          </span>
          </div>

          <div *ngIf="[puzzle_task, puzzle_example].includes(exercise.exercise_type)">
            <app-exercise-puzzle
              [exercise]="exercise"
              [index]="i"
              [viewType]="'result_modal'"
              [currentAnswer]="exercise.shortAnswer">
            </app-exercise-puzzle>
          </div>

        </div>
      </ng-container>
    </div>
  </div>
</section>
